import React from 'react';
import { createRoot } from 'react-dom/client';
import { App as AntApp, ConfigProvider } from 'antd';
import 'antd/dist/reset.css';
import '../css/app.css';
import { App } from './ui/App';

const container = document.getElementById('root');

if (container) {
    createRoot(container).render(
        <ConfigProvider>
            <AntApp>
                <App />
            </AntApp>
        </ConfigProvider>,
    );
}
